import { AlertTriangle } from 'lucide-react'

interface ConfirmDialogProps {
  isOpen: boolean
  title: string
  message: React.ReactNode
  confirmLabel?: string
  cancelLabel?: string
  isAlert?: boolean
  confirmDisabled?: boolean
  onConfirm: () => void
  onCancel: () => void
}

export default function ConfirmDialog({
  isOpen,
  title,
  message,
  confirmLabel = '削除',
  cancelLabel = 'キャンセル',
  isAlert = false,
  confirmDisabled = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-4 max-w-md w-full shadow-xl">
        <div className="flex items-center gap-2 mb-4">
          <div
            className={`p-2 rounded-full ${isAlert ? 'bg-red-100' : 'bg-blue-100'}`}
          >
            <AlertTriangle
              className={isAlert ? 'text-red-600' : 'text-blue-400'}
              size={24}
            />
          </div>
          <h3 className="text-xl font-bold">{title}</h3>
        </div>

        <div className="text-gray-600 mb-6">{message}</div>

        <div className="flex gap-4">
          <button
            onClick={onCancel}
            className="flex-1 px-6 py-3 text-base font-bold rounded-lg bg-white text-black border hover:bg-gray-100 transition-colors"
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            disabled={confirmDisabled}
            className={`flex-1 px-6 py-3 text-base font-bold rounded-lg text-white transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed ${
              isAlert
                ? 'bg-red-400 hover:bg-red-600'
                : 'bg-blue-400 hover:bg-blue-600'
            }`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  )
}
